export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '永利皇宫的入住和退房时间是几点？',
    answer: '永利皇宫标准入住时间为下午15:00，退房时间为中午12:00。如需提前入住或延迟退房，请提前联系礼宾部安排，视房态情况可免费延长至下午14:00。永利会白金卡及以上会员可享受优先入住和延迟退房至下午16:00的专属权益。',
  },
  {
    question: '永利皇宫提供哪些免费服务？',
    answer: '永利皇宫为所有宾客提供多项免费服务，包括：观光缆车无限次乘坐、免费Wi-Fi全覆盖、健身中心和泳池使用、表演湖音乐喷泉观赏、澳门主要口岸免费穿梭巴士接送、每日报纸和擦鞋服务等。入住套房的宾客还可享受免费行政酒廊使用权。',
  },
  {
    question: '如何从澳门国际机场抵达永利皇宫？',
    answer: '从澳门国际机场到永利皇宫有多种交通方式：1）免费穿梭巴士：永利皇宫在机场到达层设有专属接待柜台，免费穿梭巴士每15-20分钟一班，车程约10分钟；2）出租车：费用约澳门币50-70元，车程约8分钟；3）轻轨：乘坐澳门轻轨至路氹东站，出站后步行约5分钟即可抵达。',
  },
  {
    question: '永利皇宫的着装要求是什么？',
    answer: '永利皇宫公共区域和大部分餐厅采用休闲优雅的着装标准。日间可穿着休闲装，但泳装和浴袍仅限于泳池和水疗区域。永利宫、永利扒房和"泓"日本料理等米其林星级餐厅要求商务休闲装，男士建议穿着有领衬衫和长裤，女士建议穿着优雅连衣裙或套装。赌场区域要求穿着得体，禁止穿着拖鞋、背心和运动短裤。',
  },
  {
    question: '永利皇宫可以携带宠物入住吗？',
    answer: '目前永利皇宫暂不提供宠物入住服务，但可协助安排宠物寄养在澳门本地专业宠物酒店。如需此项服务，请至少提前72小时联系礼宾部。导盲犬等服务犬类除外，可随主人一同入住。',
  },
  {
    question: '永利皇宫的取消政策是怎样的？',
    answer: '标准预订可在入住日期前48小时免费取消。旺季（农历新年、五一黄金周、十一黄金周）预订需提前72小时取消。预付价格和促销套餐通常不可取消或修改，预订时请仔细阅读具体条款。建议选择弹性房价以获得更大灵活性。',
  },
  {
    question: '永利皇宫是否有适合儿童的活动？',
    answer: '是的，永利皇宫设有超过500平方米的儿童俱乐部，面向3-12岁儿童开放，提供手工坊、游戏区、迷你电影院等设施。酒店还设有儿童专属泳池区，配备水上滑梯和喷水设施。多家餐厅提供儿童菜单。此外，表演湖的音乐喷泉表演也是孩子们非常喜爱的免费娱乐项目。',
  },
  {
    question: '永利皇宫支持哪些支付方式？',
    answer: '永利皇宫支持多种支付方式：银联卡、Visa、Mastercard、American Express信用卡、微信支付、支付宝、澳门币现金和港币现金。酒店内所有消费均可计入房账，退房时统一结算。预订时需提供信用卡担保，实际扣款在退房时进行。',
  },
];